(function () {
    'use strict';
    angular.module('components.siteText', []);
})();